import { lazy } from "react";
import type { WidgetDefinition } from "../types";

export interface SunConfig {
  showGoldenHour: boolean;
}

// astronomy-engine is only downloaded when a sky widget is on screen.
const SunView = lazy(() => import("./SunView"));

export const sunWidget: WidgetDefinition<SunConfig> = {
  type: "sun",
  version: 1,
  name: "Sun & daylight",
  description: "Sunrise, sunset and the sun’s path today, with how much daylight you gained or lost since yesterday.",
  icon: "sun",
  category: "weather",
  defaultSize: { w: 4, h: 4 },
  minSize: { w: 2, h: 2 },
  stackHeight: 340,
  defaults: { showGoldenHour: true },
  settings: [{ key: "showGoldenHour", label: "Show golden hour", type: "toggle", help: "When the sun is low (between 6° above and 4° below the horizon): warm, soft light." }],
  provider: "astronomy-engine",
  capabilities: { requiresLocation: true },
  supportsFullscreen: true,
  Component: SunView,
};
